import { requireAnyOrgPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { checkPermissions } from './checkPermissions';
export const hasModifyPermission = (userState, ownerId, permissions) => {
    return checkPermissions(userState, ownerId, 'modify', permissions);
};
export const hasWritePermission = (userState, ownerId, permissions, rootLevel) => {
    if (!ownerId && rootLevel) {
        return requireAnyOrgPermission(userState, 'manage-documents');
    }
    return checkPermissions(userState, ownerId, 'write', permissions);
};
export const hasReadPermission = (userState, ownerId, permissions) => {
    return !!(permissions === null || permissions === void 0 ? void 0 : permissions.public) || checkPermissions(userState, ownerId, 'read', permissions);
};
